const LOGO_BY_SLUG = {
  'amity-university': '/logos/amity-university.png',
  'dy-patil-pune': '/logos/dy-patil-pune.png',
  'galgotias-university': '/logos/galgotias-university.png',
  'lovely-professional': '/logos/lovely-professional.svg',
  'manipal-jaipur': '/logos/manipal-jaipur.svg',
  'parul-university': '/logos/parul-university.svg',
  'shoolini': '/logos/shoolini.png',
  'sikkim-manipal': '/logos/sikkim-manipal.png',
  'uttranchal-university': '/logos/uttranchal-university.svg',
  'vivekanand-global-university': '/logos/vivekanand-global-university.png'
};

export function universityLogoSrc(slug, logoUrl) {
  if (typeof slug === 'string' && LOGO_BY_SLUG[slug.trim()]) {
    return LOGO_BY_SLUG[slug.trim()];
  }
  if (typeof logoUrl === 'string' && logoUrl.trim()) {
    return logoUrl.trim();
  }
  return null;
}
